module.exports = __webpack_public_path__ + "static/img/1066_small.6d2ae42.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1066_small.png
// module id = W9HL
// module chunks = 1